import React from "react";

import { Stack } from "@mui/system";
import { useTranslation } from "react-i18next";

import { AppConfig } from "../../../../constants";
import NotEnoughData from "../../../DashMetrics/NotEnoughData";
import useStyles from "./styles";

interface Props {
  data: number[];
  labels: string[];
  total: number;
}

const OverviewRatioGraph = ({ data, labels, total }: Props) => {
  const { t: translate } = useTranslation();
  const classes = useStyles();

  if (!data || !total) return <NotEnoughData onlyText />;

  const percentages = data.map((value) => (value / total) * 100);
  const { locale } = AppConfig.locale;
  const formatNumber = Intl.NumberFormat(locale, { maximumFractionDigits: 2 }).format;

  return (
    <Stack
      direction="column"
      spacing={1}
      sx={{ height: "100%", justifyContent: "space-between", width: "100%" }}
    >
      {labels.map((label, idx) => (
        <div key={`${label}_${data[idx]}`}>
          <div className={classes.dataContainer}>
            <div className={classes.total}>{formatNumber(data[idx])}</div>
          </div>
          <div className={classes.value}>
            <span>{`${formatNumber(percentages[idx])}%`}</span>
            <span>{` ${translate("ofTotal").toLocaleLowerCase()}`}</span>
            <span>{` (${formatNumber(total)})`}</span>
          </div>
        </div>
      ))}
    </Stack>
  );
};

export default OverviewRatioGraph;
